import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import { ILink } from '@models/ILink';

export interface ILinkCardBlock {
  readonly trumpetText?: string;
  readonly title: string;
  readonly text: string;
  readonly link: ILink;
}

const LinkCardBlock = ({ trumpetText, text, title, link }: ILinkCardBlock) => {
  const Tag = link.url ? 'a' : 'div';

  return (
    <section className="tw-mb-14 tw-mt-9 md:tw-mb-20 md:tw-mt-12">
      <Tag
        href={link.url}
        target={link.target}
        className="link-card -tw-mx-4 tw-block tw-bg-grey-10 tw-px-4 tw-py-6 md:tw-mx-0 md:tw-px-8"
      >
        {trumpetText && (
          <Text variant="label-12" className="tw-mb-1 tw-text-grey-70">
            {trumpetText}
          </Text>
        )}
        <div className="tw-mb-3 tw-flex tw-justify-between">
          <Text as="p" variant="ds-headline-4" className="tw-text-grey-100">
            {title}
          </Text>
          <Icon
            name={link.target === '_blank' ? 'external-link' : 'arrow-right'}
            size={20}
            className="tw-my-auto tw-ml-4 tw-shrink-0"
          />
        </div>
        <Text className="tw-line-clamp-3 tw-text-grey-80" variant="body">
          {text}
        </Text>
      </Tag>
    </section>
  );
};

export default LinkCardBlock;
